/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { NewsMediaCardFragment } from "@cosmos/hygraph-schema";

import { css, cx } from "@panda/css";

import { NewsMediaCard } from "./NewsMediaCard.molecule";

export type NewsMediaCardsProps = {
	cards?: NewsMediaCardFragment[] | null;
};

const listWrapStyle = css({
	alignItems: "stretch",
	display: "grid",
	gridTemplateColumns: { base: "4", lgDown: "2", smDown: "1" },
	gap: "eds.dimension.16",
	w: "full",
});

export function NewsMediaCards({ cards = [] }: NewsMediaCardsProps): React.JSX.Element | null {
	const mediaCards = cards || [];
	if (!mediaCards?.length) return null;

	return (
		<div className={cx("news-media-cards", listWrapStyle)}>
			{mediaCards.map((card, i) => (
				<NewsMediaCard
					key={`news-media-card-grid-item-${i}`}
					{...card}
					analytics={{
						eventCategory: "tile",
						eventLabel: card.title?.text || "",
						eventValue: {
							component: "NewsMediaCards",
							index: i,
						},
					}}
				/>
			))}
		</div>
	);
}
